<template>
  <main>
    <!-- <section>
      <div class="align-content-center m-4">
        <div class="page_title" style="display: flex;justify-content: center;">
          <div>
            <h3 class="page_title" style="display: inline-block;
                    height: 4.1rem;
                    border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">Brochure </h3>
          </div>
        </div>
      </div>
      <div style=" height: 30px;background-color: #2C2C2B;text-align: left;; line-height: 30px;">
        <div class="custom-header" style=" display: flex;text-align: center;">

        </div>
      </div>
    </section> -->
    <section>
      <div class="align-content-center m-4">
        <div class="page_title" style="display: flex;justify-content: center;">
          <div class="page_title" style="display: flex;justify-content: center;">
            <div>
              <h3 class="page_title" style="display: inline-block;
							height: 4.1rem;
							border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);"> Brochure</h3>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; width: 100%;justify-content:right;padding-right: 260px;">
        <SearchInput v-model="inputValue" style="width: 280px;" @keyEnter="searchData" />
      </div>
    </section>
    <table>
      <tr>
        <td class=" col-md-1-1" style="vertical-align: top; padding: 0;background-color: #1D1D1B;">
          <div class="tree-box" style="width: 100%;min-width: 240px;">
            <!-- <div style=" height: 40px;background-color: #434343;text-align: center; line-height: 40px;">
              <div class="custom-header" style=" display: flex;text-align: center;">
                <div style="position: relative;text-align: center;width: 100%;">
                  Annual
                </div>
               
              
              </div>
            </div> -->
            <div class="tree-content" style="margin-top: 20px;">
              <el-tree ref="treeleft" :data="treeData" node-key="id" :indent="0" class="tree-line"
                :row-style="{'padding-top':'0px','padding-bottom':'0px',height:'30px','line-height':'30px'}"
                :default-expand-all="true" :expand-on-click-node="false" @node-click="handleNodeClick">
                <span slot-scope="{ data }" class="custom-tree-node">
                  <template>
                    <div class="node_div">
                      <span class="name-box">
                        {{ data.name }}<span v-if="data.itemNum>0">({{data.itemNum}})</span>
                      </span>
                    </div>
                  </template>
                </span>
              </el-tree>
            </div>
          </div>
        </td>
        <td class="container col-md-10-1" style="vertical-align: top;padding: 0;padding-top: 30px;">
          <div style="width: 100%;text-align: center;"></div>
          <section class=" content_padding " style="margin-left: 10%;width: 80%;">
            <div class="row">
              <!-- <div class="col-md-3-1 mr-5 content_padding" v-for="item in paginatedData" :key="item.id" @click="showDetail(item)"> -->
              <div class="col-md-3-1 mr-5 content_padding" v-for="item in paginatedData" :key="item.id"
                @click="showHtml(item.pdfUrl)">
                <div class="cardborder-0">
                  <img class="card-img-top" :src="item.url" alt="Card image cap">
                  <div class="card-body card-body-list">
                    <p class="card-text text-muted multiline">{{item.happenDate.slice(0, 10)}}</p>
                    <p class="card-title card-sub-title mb-1" style="font-size: 18px;">
                      {{item.title}}
                    </p>
                    <p class="card-text text-muted multiline" v-html="item.summary">
                      <!-- {{item.summary}} -->
                    </p>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-3-1 mr-5 content_padding" @click="navigateTo()">
                <div class="cardborder-0">
                  <img class="card-img-top" src="/assets/img/Download/PBDownload1.png" alt="Card image cap">
                  <div class="card-body card-body-list">
                    <p class="card-text text-muted multiline">2024-05-27</p>
                    <p class="card-title card-sub-title mb-1">
                      2024 SANMAK Catalog <img src="/assets/img/Download/vipLogo.png">
                    </p>
                    <p class="card-text text-muted multiline">
                      Sanmak is committed to the research and development of green, safe, efficient, and energy-saving
                      products such as LED/HID.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-3-1 mr-5 content_padding" @click="navigateTo()">
                <div class="cardborder-0">
                  <img class="card-img-top" src="/assets/img/Download/PBDownload2.png" alt="Card image cap">
                  <div class="card-body card-body-list">
                    <p class="card-text text-muted multiline">2024-05-27</p>
                    <p class="card-title card-sub-title mb-1">
                      2024 SANMAK Catalog
                    </p>
                    <p class="card-text text-muted multiline">
                      Sanmak focuses on long-term development and cultural shaping, with an excellent team of
                      professional
                      managers. Adhering to the talent ...
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-3-1 mr-5 content_padding" @click="navigateTo()">
                <div class="cardborder-0">
                  <img class="card-img-top" src="/assets/img/Download/PBDownload3.png" alt="Card image cap">
                  <div class="card-body card-body-list">
                    <p class="card-text text-muted multiline">2024-05-27</p>
                    <p class="card-title card-sub-title mb-1">
                      2024 SANMAK Catalog
                    </p>
                    <p class="card-text text-muted multiline">
                      A series of selected works show the perfect integration of functional and artistic design of
                      headlights.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-3-1 mr-5 content_padding" @click="navigateTo()">
                <div class="cardborder-0">
                  <img class="card-img-top" src="/assets/img/Download/PBDownload4.png" alt="Card image cap">
                  <div class="card-body card-body-list">
                    <p class="card-text text-muted multiline">2024-05-27</p>
                    <p class="card-title card-sub-title mb-1">
                      2024 SANMAK Catalog
                    </p>
                    <p class="card-text text-muted multiline">
                      Our latest brochure showcases our new model and many new designs. Sanmak has completed the
                      relocation to another new factory, which…
                    </p>
                  </div>
                </div>
              </div> -->
            </div>
            <el-pagination background layout="prev, pager, next" :hide-on-single-page="value" :total="totalData"
              :page-size="pageSize" @current-change="handleCurrentChange" :current-page="currentPage">
            </el-pagination>
          </section>
        </td>
      </tr>
    </table>
    <!-- 详情 弹窗 -->
    <el-dialog title="Tips" :visible.sync="isdetail" width="60%" :before-close="detailClose"
      style="background-color: black;">
      <div>
        <embed :src="currentRow.pdfUrl" type="application/pdf" width="100%" height="700px">
      </div>
    </el-dialog>
  </main>
</template>

<script>
  import SearchInput from '@/components/common/SearchInput.vue';
  import { getLeftTreeList, getDataList } from "@/api/rbac/album";
  export default {
    name: 'ProductBrochure',
    components: {
      SearchInput
    },
    data() {
      return {
				inputValue: '',
        treeData: [],
        newsData: [],
        // 当前页码
        currentPage: 1,
        // 每页显示的数据条数
        pageSize: 6,
        // 总数据条数
        totalData: 0,
        value: true,
        currentRow: {},
        isdetail: false,
				originData: [],
        // yearData: [{ id: 1, name: 'Brochure', value: 0, children: [{ id: 2, name: '2023 Year', value: 2023 }, { id: 3, name: '2024 Year', value: 2024 }, { id: 4, name: '2025 Year', value: 2025 }] }],
      }
    },
    computed: {
      // 计算属性，用于获取当前页的数据
      paginatedData() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = this.currentPage * this.pageSize;
        return this.newsData.slice(start, end);
      },
      user() {
        if (this.$store.state.user == null) {
          var storUser = localStorage.getItem("token")
          if (storUser == null) {
            return this.$store.state.user
          }
          else {
            const storedUser = localStorage.getItem("token");
            var thisuser = JSON.parse(storedUser);
            return thisuser
          }

        }
        else {
          return this.$store.state.user
        }
        // 使用计算属性来获取用户信息，这样当用户信息变化时，界面也会自动更新
      },
    },
    created() {
      this.getTreeList();
    },
    methods: {
      navigateTo(id) {
        this.$router.push(`/download/DownloadDetails`);
        this.$router.push(`${this.$route.path}/0/` + id);
      },
      // 当前页码改变时的处理函数
      handleCurrentChange(page) {
        this.currentPage = page;
      },
      setDefaultNode(id) {
        // 假设你想默认聚焦的节点的 id 是 5
        this.$nextTick(() => {
          const tree = this.$refs.treeleft;
          const node = tree.getNode(id);
          if (node) {
            tree.setCurrentKey(id);
            //tree.setCurrentNode(node); // 可选，根据需求选择是否使用
          }
        });
      },
      handleNodeClick(node) {
        var strWhere = ''
        // if (this.user == null) {
        // 	strWhere = ' and a.isNew=0'
        // }
        // else{
        // 	if (this.user.isCus==1) {
        // 		strWhere=` and (a.isNew=0 or (a.isnew=1 and DATEDIFF(mm,a.happenDate,GETDATE())>=${this.user.intMonth}))`
        // 	}
        // }
        if (this.user == null) {
          strWhere = ' and DATEDIFF(mm,a.happendate,getDate())>=(select MAX(intMonth) from WebUserLevelSet)'
        }
        else {
          if (this.user.isCus == 1) {
            strWhere = ` and DATEDIFF(mm,a.happenDate,GETDATE())>=${this.user.intMonth}`
          }
        }
        if (node.pID != 0) {
          // if (node.pID == 0) {
          // this.loadDataList('')
          strWhere += ` and year(a.happenDate)='${node.realID}'`
        }
        // else {
        //   this.loadDataList(` and year(a.happenDate)='${node.realID}'`)
        // }
        this.loadDataList(strWhere)
      },
      getTreeList() {
        var strWhere = ''
        var detailWhere = ' '
        if (this.user == null) {
          strWhere = ' and b.isNew=0'
          strWhere = ' and DATEDIFF(mm,b.happendate,getDate())>=(select MAX(intMonth) from WebUserLevelSet)'
          detailWhere = ' and DATEDIFF(mm,a.happendate,getDate())>=(select MAX(intMonth) from WebUserLevelSet)'
        }
        else {
          if (this.user.isCus == 1) {
            strWhere = ` and DATEDIFF(mm,b.happenDate,GETDATE())>=${this.user.intMonth}`
            detailWhere = ` and year(a.happenDate)>=year(getDate())-2 and DATEDIFF(mm,a.happenDate,GETDATE())>=${this.user.intMonth}`
          }
        }
        // if (this.user == null) {
        // 	strWhere = ' and b.isNew=0'
        // 	detailWhere = ' and a.isNew=0'
        // }
        // else{
        // 	if (this.user.isCus==1) {
        // 		strWhere=` and (b.isNew=0 or (b.isnew=1 and DATEDIFF(mm,b.happenDate,GETDATE())>=${this.user.intMonth}))`
        //     detailWhere = ` and year(a.happenDate)>=year(getDate())-2 and (a.isNew=0 or (a.isnew=1 and DATEDIFF(mm,a.happenDate,GETDATE())>=${this.user.intMonth}))`
        // 	}
        // }
        getLeftTreeList({ strWhere: strWhere }).then(res => {
          this.treeData = res.data;
          if (this.treeData.length > 0 && this.treeData[0].children.length > 0) {
            this.$nextTick(() => {
              this.$refs.treeleft.setCurrentKey(this.treeData[0].id);
            });
          }
          this.loadDataList(detailWhere)
        })
      },
      async loadDataList(strWhere) {
        this.currentPage = 1;
        try {
          getDataList({ strWhere: strWhere }).then(res => {
            this.totalData = res.data.length;
            if (res.data.length == 0) {
              // console.log(this.dataList)
              this.newsData = [];
            }
            else {
              this.newsData = res.data;
              this.newsData.forEach(comNew => {
                comNew.url = "../../../assets/img/album/" + comNew.url;
                //comNew.pdfUrl = "../../../assets/img/album/" + comNew.pdfUrl;
              });
            }

          })
        } catch (error) {
          console.error('获取失败:', error);
        }
      },
      showDetail(content) {
        this.currentRow = content
        this.isdetail = true;
      },
      detailClose() {
        this.currentRow = {}
        this.isdetail = false;
      },
      showHtml(strHtml) {
        var str = '/Brochure/' + strHtml + '/' + strHtml + '.html'
        window.open(str, '_blank');
      },
      searchData(value) {
        if (this.originData.length == 0) {
          this.originData = this.newsData
        }
        if (value.length == 0) {
          this.newsData = this.originData
          this.originData = []
        }
        else {
          this.newsData = this.originData.filter(product => product.title.toLowerCase().includes(value.toLowerCase())||product.summary.toLowerCase().includes(value.toLowerCase()));
        }
        this.currentPage = 1;
        this.totalData = this.newsData.length
      },
    },
    mounted() {
      this.setDefaultNode(1);
    },
  };
</script>

<style scoped>
  @import '../../assets/css/main.css';

  .tree-line {
    background-color: transparent;
    color: #D3D3D2;
  }

  ::v-deep .el-tree-node.is-current>.el-tree-node__content {
    background: #FCB42E !important;
    color: black;
  }

  :deep(.card) {
    background-color: transparent;
  }

  :deep(.card-title) {
    font-weight: 400;
    margin-bottom: 0rem;
  }

  :deep(.card-sub-title) {
    color: #fff;
    height: 1.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  :deep(.card-img-top) {
    min-height: 16rem;
    max-height: 16rem;
    background: linear-gradient(to bottom right, #2C2C2C, #000000);
  }

  :deep(.card-body) {
    padding: 1rem 0;
  }

  :deep(.card-body-list) {
    text-align: left;
    height: 10rem;
    background-color: transparent;
    border-bottom-left-radius: calc(0.25rem - 1px);
    border-bottom-right-radius: calc(0.25rem - 1px);
  }

  :deep(.card-body-list img) {
    margin-left: 0.8rem;
    max-width: 1.2rem;
    max-height: 1.2rem;
  }

  :deep(.multiline) {
    color: #5F5F5F !important;
    overflow: hidden;
    font-size: 15px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }

  :deep(.el-dialog__body) {
    background: gray;
  }

  :deep(.el-dialog__header) {
    background: #DDE3E9;
  }
</style>